"use client";

import { motion } from "framer-motion";
import Image from "next/image";

const logos = [
  {
    src: "/client-logos/seneca.png",
    width: 149,
    height: 30,
    alt: "Seneca Resources Logo",
  },
  {
    src: "/client-logos/dsider-logo-black.png",
    width: 149,
    height: 30,
    alt: "Dsider Logo",
  },
  {
    src: "/client-logos/pneumatech-logo-black.png",
    width: 181,
    height: 28,
    alt: "Pneumatech Logo",
  },
  {
    src: "/client-logos/recon-logo-black.png",
    width: 178,
    height: 51,
    alt: "Recon Logo",
  },
  {
    src: "/client-logos/deepsee.png",
    width: 178,
    height: 51,
    alt: "Recon Logo",
  },
];

export default function TrustedByLogos() {
  return (
    <div className="z-20 relative px-5">
      <p className="mb-5 text-center font-mono text-zinc-900">Trusted By</p>
      <div className="flex flex-col md:flex-row items-center justify-center gap-10">
        {logos.map((logo, index) => (
          <motion.div
            key={logo.src}
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: index * 0.3, duration: 0.6 }}
          >
            <Image
              src={logo.src}
              width={logo.width}
              height={logo.height}
              className="w-50 h-auto"
              alt={logo.alt}
            />
          </motion.div>
        ))}
      </div>
    </div>
  );
}
